<!-- Copyright 2023 (Unpublished) Verto Inc. -->

<div class="login-container">
  <div class="login-left-container">
    <div class="login-title-container">
      <img src="assets/images/arrow-click.png" class="login-title-image" />
      <div class="login-title">Sign In to Verto Automate</div>
    </div>
    <form class="login" [formGroup]="loginForm" (submit)="login()">
      <div class="form-group">
        <label class="login-field-label">Your email:</label>
        <input type="email" class="form-control login-field" placeholder="Email" formControlName="email" />
      </div>
      <div class="form-group">
        <label class="login-field-label">Password:</label>
        <input type="password" class="form-control login-field" placeholder="password" formControlName="password" />
      </div>
      <div class="login-buttons">
        <button type="submit" [disabled]="loading" class="btn btn-primary login-button">
          Sign In
          <fa-icon [icon]="faChevronRight" class="login-icon"></fa-icon>
        </button>
        <p>
          Or Sign in with
          <button (click)="signInWithFlow()" class="oauth-provider" type="button" [disabled]="loading">
            <img alt="verto" src="assets/images/flow-logo.png" />
          </button>
        </p>
      </div>
    </form>
    <div *ngIf="invalid" class="login-error">Invalid email or password</div>
  </div>
  <div class="login-right-container">
    Powered by
    <img src="assets/images/verto-logo.png" class="login-logo" />
    <img src="assets/images/lock-and-key.png" class="login-logo-lock" />
  </div>
</div>
